// org-match.guard.ts
import { CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserService, Organization } from '../services/user.service';

export const organizationsAllowedAccess = (
  allowed: Organization[] | Organization,
  redirect: string
): CanMatchFn => {
  const allowedSet = new Set(Array.isArray(allowed) ? allowed : [allowed]);

  return () => {
    const userService = inject(UserService);
    const router = inject(Router);

    const organization = userService.getOrganization(); // 'assetworks-employee' | 'integration-employee' | null
    if (organization && allowedSet.has(organization)) {
      return true;
    }

    if (redirect === 'integration-details') {
      const organizationId = userService.getUserInfo()?.organizationId;
      return router.createUrlTree([
        '/integration-management/integration-details',
        organizationId ?? '',
      ]);
    }

    // redirect to dashboard if not allowed
    return router.createUrlTree([redirect]);
  };
};
